import React from "react";
import { usePagesTranslation } from "../../../../pages/locales";
import { SLIDING_APPEARANCE_DARK, SLIDING_APPEARANCE_LIGHT } from "../lib/appearance";
import { useSlidingAppearance } from "../lib/AppearanceContext";
import { GroupedRow } from "./IOSGroupedList";
import SegmentedControl from "./SegmentedControl";

export default function AppearancePicker() {
    const { t } = usePagesTranslation();
    const { mode, setMode } = useSlidingAppearance();

    const options = [
        {
            value: SLIDING_APPEARANCE_LIGHT,
            label: t("native.settings.appearanceLight", { defaultValue: "Light" }),
        },
        {
            value: SLIDING_APPEARANCE_DARK,
            label: t("native.settings.appearanceDark", { defaultValue: "Dark" }),
        },
    ];

    return (
        <GroupedRow last>
            <SegmentedControl
                aria-label={t("native.settings.appearanceSection", { defaultValue: "Appearance" })}
                options={options}
                value={mode}
                onChange={setMode}
            />
        </GroupedRow>
    );
}
